import z from "zod";
import { IntegrationIdScheme, StockLocationIdScheme } from "./ids";
import { IntegrationType } from "./enums/IntegrationType";

export const ProductSyncSettingsShopifyScheme = z.object({
  type: z.literal(IntegrationType.SHOPIFY),
  integrationId: IntegrationIdScheme,
  enabled: z.boolean(),
  syncToShopify: z.boolean().optional(),
  syncFromShopify: z.boolean().optional(),
  primaryLocationId: z.string().nullable(),
  stockLocationId: StockLocationIdScheme.nullable().optional(),
  vatIncludedInPrice: z.boolean(),
  publicationIds: z.array(z.string()),
  autoPublishProducts: z.boolean(),
  productImportTag: z.string().nullable(),
  variantExtraFieldKeys: z.array(z.string()).max(3).optional(),
});

export const ProductSyncSettingsScheme = z.discriminatedUnion("type", [
  ProductSyncSettingsShopifyScheme,
]);

export type ProductSyncSettingsShopify = z.infer<
  typeof ProductSyncSettingsShopifyScheme
>;
export type ProductSyncSettings = z.infer<typeof ProductSyncSettingsScheme>;
